<template>
  <h2 class="my-title">{{ text }}</h2>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'My Title'
    }
  }
}
</script>

<style>
.dx-viewport .my-title.my-title {
  margin: 4px 0 10px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.015em;
  color: var(--text);
}
</style>
